import { __assign, __rest } from "tslib";
import React from 'react';
import SubscribeButton from '../../Button/SubscribeButton';
import EditTierButton from '../../Tier/EditTierButton';
import TierPromotionCardDumb from '../TierPromotionCardDumb';
var TierPromotionCard = function (_a) {
    var deviation = _a.deviation, ctaButton = _a.ctaButton, onClick = _a.onClick, props = __rest(_a, ["deviation", "ctaButton", "onClick"]);
    if (!deviation.tier) {
        return null;
    }
    var _b = deviation.title, title = _b === void 0 ? '' : _b, author = deviation.author, tier = deviation.tier, coverImage = deviation.coverImage;
    var _c = tier || {}, dollarPrice = _c.dollarPrice, _d = _c.stats, _e = _d === void 0 ? {} : _d, _f = _e.subscribers, numSubscribers = _f === void 0 ? 0 : _f;
    return (React.createElement(TierPromotionCardDumb, __assign({ author: author, coverImage: coverImage, description: title, numSubscribers: numSubscribers, formattedPrice: dollarPrice, onClick: function () { return onClick && onClick(deviation); }, ctaButton: ctaButton === 'subscribe' ? (React.createElement(SubscribeButton, { tier: deviation })) : ctaButton === 'edit' ? (React.createElement(EditTierButton, { tier: deviation })) : undefined }, props)));
};
TierPromotionCard.displayName = 'TierPromotionCard';
export default TierPromotionCard;
//# sourceMappingURL=TierPromotionCard.js.map